<template>
  <div class="main">
    <div
      style="height:120px;font-size:40px;font-weight:bold;text-align:center;padding-top:5px;letter-spacing:5px;line-height:120px"
    ></div>
    <div class="home" @click="gohome"></div>
    <div class="navliu" @click="goliu"></div>
    <div class="chart1" v-if="true">
      <div id="myChart1" style="height:100%;width:100%"></div>
    </div>
    <div class="chart2" v-if="true">
      <div id="myChart2" style="height:100%;width:100%"></div>
      <!-- <div id="myChart2" style="height:260px;width:100%"></div> -->
    </div>
    <div class="chart3" v-if="false">
      <el-row type="flex" style="margin-right:30px;margin-top:30px;">
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政强制</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政检查</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政许可</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政奖励</div>
        </el-col>
        <el-col>
          <svgprogress type="circle" :options="options3" value="22"></svgprogress>
          <div>行政处罚</div>
        </el-col>
      </el-row>
      <div class="chart3part2">
        <el-row type="flex">
          <el-col style="margin-left:10px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政强制措施</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政强制执行</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>行政监督检查</div>
          </el-col>
          <el-col style="margin-left:70px;">
            <svgprogress type="circle" :options="options3" value="22"></svgprogress>
            <div>其他行政权力</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="chart4" v-if="true">
      <!-- <div id="myChart4" style="height:100%;width:100%"></div> -->
      <el-row style="margin-top:2px;margin-left:0px;">
        <el-col style="width:145px;font-size:12px;text-align:right;">食品药品监督管理局</el-col>
        <el-col style="width:120px;margin-left:5px;">
          <svgprogress type="rect" :options="options" value="80"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">180</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">林业和草原局</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">165</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">市场监督管理局</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="55"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">155</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">国有资产监督管理委员会</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="25"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">125</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">农牧厅</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="75"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">175</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">水利厅</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="65"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">165</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">生态环境厅</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="15"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">115</el-col>
      </el-row>
      <el-row style="margin-top:2px;margin-left:20px;">
        <el-col style="width:120px;font-size:12px;text-align:right;">自然资源厅</el-col>
        <el-col style="width:120px;margin-left:10px;">
          <svgprogress type="rect" :options="options" value="95"></svgprogress>
        </el-col>
        <el-col style="width:10px;font-size:12px;margin-left:10px;">983</el-col>
      </el-row>
    </div>
    <div class="chart5" v-if="false">
      <div id="myChart5" style="height:100%;width:100%"></div>
    </div>
    <div class="chart6" v-if="false">
      <div id="myChart6" style="height:100%;width:100%"></div>
    </div>
    <div class="chart7" v-if="true">
      <!-- <div id="myChart7" style="height:100%;width:100%"></div> -->
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">环境污染</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="55"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">155</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">非法采矿</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="65"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">165</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">生产、销售不符合安全标准食品</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="45"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">145</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">生产、销售假药</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="75"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">175</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">生产、销售劣药</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="95"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">196</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">盗伐林地</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="85"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">186</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">非法占有草原</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="35"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">134</el-col>
      </el-row>
      <el-row style="margin-top:5px;margin-left:20px;">
        <el-col style="width:180px;font-size:24px;text-align:right;">其他</el-col>
        <el-col style="width:240px;margin-left:10px;">
          <svgprogress type="rect" :options="options7" value="15"></svgprogress>
        </el-col>
        <el-col style="width:30px;font-size:12px;margin-left:10px;">151</el-col>
      </el-row>
    </div>
    <div class="chart8" v-if="true">
      <div id="myChart8" style="height:100%;width:100%"></div>
    </div>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
import svgprogress from "svg-progress-bar";
import echarts from "echarts";
export default {
  name: "Index",
  components: {
    G2World,
    svgprogress
  },
  data() {
    return {
      serverData: [],
      options: {
        rectRadius: 8,
        rectWidth: 120,
        gradientColor: ["rgb(114, 150, 236)", "rgb(83,233, 222)"],
        varyStrokeArray: [15, 12],
        textColor: "rgba(0,0,0,0)",
        pathColors: ["#6387ae", "#0a2e48"]
      },
      options7: {
        rectRadius: 8,
        gradientColor: ["rgb(114, 150, 236)", "rgb(83,233, 222)"],
        varyStrokeArray: [20, 15],
        textColor: "rgba(0,0,0,0)",
        pathColors: ["#6387ae", "#0a2e48"]
      },
      options3: {
        pathColors: ["#1b475c", "#54e8df"],
        textColor: "#FFF"
      }
    };
  },
  props: {},
  mounted: function() {
    this.myChart1();
    this.myChart2();
    //this.myChart3();
    //this.myChart4();
    //this.myChart5();
    //this.myChart6();
    //this.myChart7();
    this.myChart8();
  },
  methods: {
    gohome() {
      this.$router.push({ path: "/home" });
    },
    goliu() {
      this.$router.push({ path: "/liu" });
    },
    // 各渠道线索数
    myChart2() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart2"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        color: [
          "#55c1e5",
          "#6bcfc8",
          "#6ac9e2",
          "#8870c5",
          "#6abeec",
          "#77a8e4",
          "#6abdec",
          "#9d74d5"
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        calculable: true,
        series: [
          {
            name: "各渠道线索数",
            type: "pie",
            radius: [30, 110],
            roseType: "area",
            label: {
              formatter: "{b} \n {d}%",
              textStyle: {
                fontSize: 24
              }
            },
            data: [
              { value: 10, name: "贴吧" },
              { value: 5, name: "问答" },
              { value: 15, name: "新闻" },
              { value: 25, name: "论坛" },
              { value: 20, name: "微博" },
              { value: 35, name: "微信公众号" },
              { value: 30, name: "博客" },
              { value: 40, name: "传统纸媒" }
            ]
          }
        ]
      };
      myChart.setOption(option);
    },
    // 近一个月采集总量
    myChart1() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart1"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#11ccd3"],
        color: ["#11c8d5"],
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "20%",
          left: "0%",
          right: "3%",
          bottom: "5%",
          width: "96%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["第一周", "第二周", "第三周", "第四周"],
          axisLabel: {
            fontSize: "16"
          },
          axisLabel: {
            color: "#ffffff"
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: "16",
            color: "#868686"
          }
        },
        series: [
          {
            name: "数据",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134],
            areaStyle: {},
            smooth: true
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart3() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart3"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#e9dc81"],
        title: {
          text: "案件来源",
          textStyle: {
            fontSize: "16"
          },
          top: 20
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              fontSize: 12,
              color: "#04a8f2"
            },
            formatter: a => {
              return `${a}`;
            }
          },
          indicator: [
            { name: "行政执法单位", max: 6500 },
            { name: "互联网", max: 16000 },
            { name: "群众举报", max: 30000 },
            { name: "统一业务应用系统", max: 38000 },
            { name: "卫星影像", max: 52000 },
            { name: "其它", max: 25000 }
          ]
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                label: {
                  normal: {
                    show: true,
                    formatter: function(params) {
                      return params.value;
                    },
                    fontSize: 12,
                    color: "#04a8f2",
                    fontWeight: "bold"
                  }
                },
                itemStyle: {
                  color: "#e9dc81"
                }
              }
            ]
          }
        ]
      });
    },
    myChart7() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart7"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          data: ["民事公益诉讼", "行政公益诉讼"],
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{b}\n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "民事公益诉讼" },
              { value: 310, name: "行政公益诉讼" }
            ]
          }
        ]
      });
    },
    myChart5() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart5"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "公\n安\n厅",
              "民\n政\n厅",
              "司\n法\n厅",
              "财\n政\n厅",
              "自\n然\n资\n源\n厅",
              "生\n态\n环\n境\n厅",
              "住\n房\n和\n城\n乡\n建\n设\n厅",
              "交\n通\n运\n输\n厅",
              "水\n利\n厅",
              "农\n牧\n厅",
              "商\n务\n厅",
              "文\n化\n和\n旅\n游\n厅",
              "卫\n生\n健\n康\n委\n员\n会",
              "退\n役\n军\n人\n事\n务\n厅",
              "审\n计\n厅",
              "市\n场\n监\n督\n管\n理\n局",
              "能\n源\n局",
              "林\n业\n和\n草\n原\n局",
              "地\n方\n金\n融\n监\n督\n管\n理\n局",
              "医\n疗\n保\n障\n局",
              "文\n物\n局",
              "药\n品\n监\n督\n管\n理\n局"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500
            ]
          }
        ]
      });
    },
    myChart6() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart6"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "文\n书\n鉴\n定",
              "痕\n迹\n鉴\n定",
              "声\n像\n资\n料",
              "环\n境\n损\n害",
              "司\n法\n会\n计",
              "计\n算\n机\n鉴\n定",
              "建\n筑\n工\n程",
              "知\n识\n产\n权",
              "产\n品\n质\n量",
              "化\n工\n类",
              "资\n产\n评\n估",
              "农\n业\n类",
              "水\n产\n类",
              "林\n业\n类",
              "矿\n产\n类",
              "其\n他"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500,
              7500
            ]
          }
        ]
      });
    },
    myChart4() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart4"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fa3af", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["2016", "2017", "2018", "2019"],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [4100, 6100, 8100, 7500]
          },
          {
            name: "国有土地使用权出让",
            type: "bar",
            data: [8000, 4500, 4600, 3800]
          },
          {
            name: "生态资源",
            type: "bar",
            data: [6300, 6400, 7800, 6200]
          },
          {
            name: "国有财产",
            type: "bar",
            data: [3800, 4100, 4200, 2500]
          },
          {
            name: "英烈权益",
            type: "bar",
            data: [4500, 3000, 4300, 5500]
          }
        ]
      });
    },
    // 各盟市线索统计图
    myChart8() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart8"),
        "dark"
      );
      var option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function(params, ticket, callback) {
            var showHtm = "";
            var name = "";
            for (var i = 0; i < params.length; i++) {
              //x轴名称
              name = params[i].name;
              //名称
              var text = params[i].seriesName;
              var marker = params[i].marker;
              //值
              var value = Math.abs(params[i].value);
              showHtm += "" + text + " ：" + value + "<br>";
            }

            return name + "<br/>" + showHtm;
          }
        },
        legend: {
          data: ["2018", "2019"],
          textStyle: {
            fontSize: 20
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "value",
            show: false
          }
        ],
        yAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: [
              "兴安盟",
              "阿拉善盟",
              "锡林郭勒盟",
              "巴彦淖尔市",
              "鄂尔多斯市",
              "乌兰察布市",
              "呼伦贝尔市"
            ],
            show: true,
            axisLabel: {
              textStyle: {
                fontSize: 22
              }
            }
          }
        ],
        series: [
          {
            name: "2019",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true,
                position: "right",
                textStyle: {
                  fontSize: 16
                }
              }
            },
            itemStyle: {
              normal: {
                barBorderRadius: [0, 40, 40, 0],
                color: new echarts.graphic.LinearGradient(
                  1,
                  0,
                  0,
                  0, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: "#95baff"
                    },
                    {
                      offset: 1,
                      color: "#9397ef"
                    }
                  ]
                )
              }
            },
            data: [320, 302, 341, 374, 390, 450, 420]
          },
          {
            name: "2018",
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                show: true,
                position: "left",
                formatter: function(value) {
                  return Math.abs(value.data);
                },
                textStyle: {
                  fontSize: 16
                }
              }
            },
            itemStyle: {
              normal: {
                barBorderRadius: [40, 0, 0, 40],
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  0, //渐变色在下面修改，这里是透明度
                  [
                    {
                      offset: 0,
                      color: "#abddec"
                    },
                    {
                      offset: 1,
                      color: "#83dcfe"
                    }
                  ]
                )
              }
            },
            data: [-120, -132, -101, -134, -190, -230, -210]
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");

.main {
  background: url("../assets/yuan2.png") no-repeat;
  background-size: 100%;
  width: 2880px;
  height: 1080px;
  color: #ffffff;
}

.border {
  background: url("../assets/border3.png") no-repeat;
  background-size: 100% 300px;
  width: 100%;
  height: 300px;
  padding: 5px 5px;
}

.diqiu {
  background: url("../assets/diqiu.png") no-repeat;
  background-size: 334px 263px;
  background-position: center;
  width: 100%;
  height: 263px;
  padding: 5px 5px;
}
.title {
  font-size: 50px;
}

.myChart {
  /* border: #ffffff 2px dashed; */
  width: 96%;
  padding: 5px 30px;
}

.border img {
  width: 120px;
  margin-left: 10px;
}

.box-title {
  text-align: left;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 40px;
}

.group {
  background: url("../assets/img_product/group.png") no-repeat;
  width: 450px;
  height: 275px;
  padding-left: 20px;
  margin-left: 50px;
}

.groupnumber {
  color: #75eaff;
}

.groupcontent {
  color: #bccad4;
}

.home {
  position: absolute;
  left: 147px;
  top: 44px;
  width: 120px;
  height: 96px;
  cursor: pointer;
}

.chart1 {
  position: absolute;
  left: 96px;
  top: 177px;
  width: 523px;
  height: 359px;
  /* border: 1px solid #ffffff; */
}

.chart2 {
  position: absolute;
  left: 118px;
  top: 620px;
  width: 524px;
  height: 382px;
  border: 0px solid #ffffff;
}

.chart3 {
  position: absolute;
  left: 74px;
  top: 725px;
  width: 912px;
  height: 277px;
  border: 0px solid #ffffff;
  font-size: 14px;
  color: #9fbbd0;
  text-align: center;
}

.chart4 {
  position: absolute;
  left: 650px;
  top: 800px;
  width: 321px;
  height: 208px;
}

.chart5 {
  position: absolute;
  left: 1028px;
  top: 701px;
  width: 834px;
  height: 290px;
  border: 0px solid #ffffff;
}

.chart6 {
  position: absolute;
  left: 1923px;
  top: 497px;
  width: 543px;
  height: 195px;
  border: 0px solid #ffffff;
}

.chart7 {
  position: absolute;
  left: 2271px;
  top: 190px;
  width: 522px;
  height: 335px;
  border: 0px solid #ffffff;
}

.chart8 {
  position: absolute;
  left: 2286px;
  top: 623px;
  width: 522px;
  height: 385px;
  border: 0px solid #ffffff;
}

.chart3part2 {
  position: absolute;
  left: 120px;
  top: 140px;
  font-size: 14px;
  color: #9fbbd0;
}

.navliu {
  position: absolute;
  left: 1183px;
  top: 456px;
  width: 120px;
  height: 120px;
  cursor: pointer;
  z-index: 1;
}
</style>
